export const routeList = [
    {
        id: 1,
        path: '/home',
    },
    {
        id: 1,
        path: '/permit',
    },
    {
        id: 1,
        path: '/softwareLis',
    },
    {
        id: 1,
        path: '/privacy',
    },
    {
        id: 2,
        path: '/news',
    },
    {
        id: 2,
        path: '/996news',
    },
    {
        id: 2,
        path: '/newsDetail',
    },
    {
        id: 1,
        path: '/aboutUs',
    },
    {
        id: 1,
        path: '/productInfo',
    },
    {
        id: 1,
        path: '/contactUs',
    },
    {
        id: 1,
        path: '/gameDetail',
    },
    {
        id: 3,
        path: '/liveHome',
    }
]
